<template>
  <div class="main-page">
    <div v-show="!showMask">
      <div class="global-map">
        <chartMap></chartMap>
      </div>
      <div class="real-time-data">海外疫情实时数据</div>
      <div class="content-box">
        <div v-if="isFixed" style="height: 75px;width: 100%;" class="fix-fill"></div>
        <div :class="isFixed ? 'fixed' : ''" class="nav-tab">
          <div ref="tab1" @click="switchTab('timelineContent')" class="time-line-tab">
            <div ref="tabTriangle1" class="triangle"></div>重点国家疫情大事记
          </div>
          <div ref="tab2" @click="switchTab('sanKey')" class="sangkey-chart-tab">
            <div ref="tabTriangle2" class="triangle"></div>广东境外输入病例来源
          </div>
        </div>
        <div class="tab-content">
          <transition mode="out-in">
            <keep-alive>
              <component :isFixed="false" @emitClose="closeMask" :is="currentTabComponent"></component>
            </keep-alive>
          </transition>
        </div>
      </div>
       <div v-show="showDownLoad" class="downLoad-box">
        <img v-if="!deviceId" class="download-img" src="../../assets/images/download@2x.png" @click="downLoad" />
      </div>
      <div class="footer">
        <div class="nf-plus">
          <img class="nfrb" src="../../assets/images/nfrb.png" />
          <img src="@/assets/images/icon_logo.png" alt class="icon" />
          <div class="text-box">
            <p class="text">南方日报、南方+客户端出品</p>
            <p class="text">转载请标明出处</p>
          </div>
        </div>
      </div>
    </div>
    <div class="page_loading" v-show="showMask">
      <img src="@/assets/images/loading.gif" alt class="icon" />
      <p class="progress">{{progress}}%加载中</p>
    </div>
  </div>
</template>

<script>
import openApp from "@/utils/openApp.js";
  import {
    initShare
  } from "@/utils/share";
  import timelineContent from "../timeLineContent/index.vue";
  import chartMap from "@/components/chartMap/index";
  import sanKey from "@/components/sankey/index.vue";
  import {
    savePoint
  } from "@/utils/savePoint";
  export default {
    components: {
      timelineContent,
      chartMap,
      sanKey
    },
    data() {
      return {
        currentTabComponent: "timelineContent",
        isFixed: false,
        progress: 0,
        showMask: true,
        move: 0,
        timer: null,
        androidDownLoad: false,
        deviceId: false,
        showDownLoad: false
      };
    },
    created() {
      this.countDown();
      this.md();
    },
    computed: {
      activeTimeline() {
        return this.currentTabComponent === "timelineContent";
      }
    },
    methods: {
      downLoad() {
        openApp({
          address: window.location.href
        })
      },
      md() {
        savePoint({
          deviceid: window.localStorage.getItem("nfplus_deviceid"),
          dataType: "1000099",
          actionTime: Date.parse(new Date()),
          url: location.href,
          refer: document.referrer,
          origin: "5", // 5 - 国际疫情大事记 H5
          action: "1" // 访问首页
        });
      },
      switchTab(key) {
        this.$refs["tab1"].style.backgroundColor = "#c7ccd5";
        this.$refs["tab2"].style.backgroundColor = "#c7ccd5";
        this.$refs["tabTriangle1"].style.transform = "rotate(90deg)";
        this.$refs["tabTriangle2"].style.transform = "rotate(90deg)";
        let target = event.currentTarget;
        target.style.backgroundColor = "#ff604e";
        target.firstChild.style.transform = "rotate(0)";
        this.currentTabComponent = key;
        if (key == "timelineContent") {
          savePoint({
            deviceid: window.localStorage.getItem("nfplus_deviceid"),
            dataType: "1000099",
            actionTime: Date.parse(new Date()),
            url: window.location.href,
            origin: "5",
            action: "17"
          });
        } else if (key == "sanKey") {
          savePoint({
            deviceid: window.localStorage.getItem("nfplus_deviceid"),
            dataType: "1000099",
            actionTime: Date.parse(new Date()),
            url: window.location.href,
            origin: "5",
            action: "15"
          });
        }
        window.scrollTo(0,document.querySelector(".global-map").offsetHeight)
      },
      // 关闭遮罩层
      closeMask() {
        this.progress = 100;
        this.showMask = false;
        clearTimeout(this.timeDown);
      },
      // 进度
      countDown() {
        if (this.progress > 98) {
          clearTimeout(this.timeDown);
          return;
        }
        this.timeDown = window.setTimeout(() => {
          this.progress = this.progress + 1;
          this.countDown();
        }, 10);
      },
      handleTouch() {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        let scroll = scrollTop - this.move;
        this.move = scrollTop;
        if (scroll > 20) {
          if (this.currentTabComponent == "timelineContent") {
            savePoint({
              deviceid: window.localStorage.getItem("nfplus_deviceid"),
              dataType: "1000099",
              actionTime: Date.parse(new Date()),
              url: window.location.href,
              origin: "5",
              action: "18"
            });
          } else if (this.currentTabComponent == "sanKey") {
            savePoint({
              deviceid: window.localStorage.getItem("nfplus_deviceid"),
              dataType: "1000099",
              actionTime: Date.parse(new Date()),
              url: window.location.href,
              origin: "5",
              action: "16"
            });
          }
        } else {
          return;
        }
      },
      handleScroll() {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        let scroll = scrollTop - this.move;
        this.move = scrollTop;
        let mapHeight = document.querySelector(".global-map").offsetHeight;
        if (scrollTop >= mapHeight) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
      },
      async getDeviceId() {
        try {
          let id = await window.nfplusJsbridge.getDeviceId();
          this.deviceId = id
        } catch (e) {
          console.error(e)
        }
        
      }
    },
    mounted() {
      document.addEventListener("touchend", this.handleTouch, true);
      document.addEventListener("scroll", this.handleScroll, true);
      initShare();
      this.getDeviceId();
      this.$nextTick(() => {
        this.showDownLoad = true
      })
    },
    destroyed() {
      document.removeEventListener("touchend", this.handleTouch, true);
      document.removeEventListener("scroll", this.handleScroll, true);
    }
  };
</script>

<style lang="less" scoped="scoped">
.real-time-data {
  text-align: center;
  font-size: 12px;
  color: grey;
  margin-top: 10px;
}
  .v-enter,
  .v-leave-to {
    opacity: 0;
  }

  .v-enter-active,
  .v-leave-active {
    transition: all 0.5s ease;
  }

  .page_loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .progress {
      color: #ff604e;
      text-align: center;
      margin-top: 10px;
    }

    img {
      width: 60px;
    }
  }

  .active {
    background-color: #ff604e !important;
  }

  .tabStyle {
    width: 178px;
    height: 26px;
    background-color: #c7ccd5;
    border-radius: 3px;
    font-family: MicrosoftYaHei;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 12px;
    letter-spacing: 1px;
    color: #ffffff;
    line-height: 26px;
    text-align: center;

    .triangle {
      content: "";
      width: 0;
      height: 0;
      overflow: hidden;
      font-size: 0;
      line-height: 0;
      border-width: 5px;
      position: absolute;
      top: 10px;
      right: 3px;
      border-style: solid dashed dashed dashed;
      border-color: #f2f2f2 transparent transparent transparent;
      transform-origin: center 2px;
      transition: all 0.5s;
    }
  }

  .main-page {
    .content-box {
      .fixed {
        position: fixed !important;
        top: 0;
        left: 0;
        z-index: 50;
        width: 100%;
      }

      .nav-tab {
        height: 75px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
        align-items: center;
        background: #f9f9f8;
        z-index: 99;

        .time-line-tab {
          .tabStyle();
          background-color: #ff604e;
          position: relative;
        }

        .sangkey-chart-tab {
          .tabStyle();
          position: relative;
          padding-right: 10px;

          .triangle {
            transform: rotate(90deg);
          }
        }
      }
    }

    .downLoad-box {
        width: 100%;
        height: 72px;
        margin-top: 20px;
        background-color: #f9f9f8;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
        align-items: center;
        .download-img {
          display: block;
          width: 188px;
          height: 44px;
        }
      }

    .footer {
      width: 100%;
      height: 72px;
      background-color: #ffffff;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-around;
      align-items: center;

      .nf-plus {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        .nfrb {
          width: 86px;
          height: 30px;
          margin-right: 15px;
        }
        .icon {
          width: 36px;
          display: block;
          margin-right: 10px;
        }

        .text-box {
          .text {
            font-family: MicrosoftYaHei;
            font-size: 11px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 1px;
            color: #6d6d6d;
          }
        }
      }
    }
  }
</style>
